import { FieldValidation } from '@rjsf/utils';

import { ApiHolder } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { FieldExtensionUiSchema } from '@backstage/plugin-scaffolder-react';

import { TextInputUiOptions } from './TextInput';

export const textInputValidation = async (
  value: string,
  validation: FieldValidation,
  context: {
    apiHolder: ApiHolder;
    uiSchema?: FieldExtensionUiSchema<string, TextInputUiOptions>;
  },
): Promise<void> => {
  if (!value) {
    return;
  }

  const uniqueConfig = context?.uiSchema?.['ui:options']?.unique;
  if (!uniqueConfig) {
    return;
  }

  const catalogApi = context?.apiHolder?.get(catalogApiRef);
  if (!catalogApi) {
    return;
  }

  const filter: Record<string, string> = {
    kind: uniqueConfig.kind,
    'metadata.name': value.toLocaleLowerCase(),
  };
  if (uniqueConfig.type) {
    filter['spec.type'] = uniqueConfig.type;
  }

  try {
    const { items } = await catalogApi.getEntities({
      filter,
      fields: ['metadata.name'],
    });

    if (items.length > 0) {
      validation.addError(
        'This name is already in use. Please choose a different name.',
      );
    }
  } catch {
    // Skip validation if the catalog API call fails for any reason, to avoid blocking users
  }
};
